import route from "./modules/route";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/about.vue"),
  },
  ...route,
];

export default routes;
